import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const Gear: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.666 9a1.667 1.667 0 11-3.333 0 1.667 1.667 0 013.333 0z"
        fill={color}
        fillOpacity={0.2}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.166.667h1.667l.608 1.823c.773.17 1.496.475 2.143.888l1.72-.86 1.178 1.179-.86 1.719a6.63 6.63 0 01.888 2.143l1.823.608v1.666l-1.823.608a6.63 6.63 0 01-.888 2.143l.86 1.72-1.179 1.178-1.719-.86a6.628 6.628 0 01-2.143.889l-.608 1.822H8.166l-.607-1.822a6.627 6.627 0 01-2.143-.889l-1.72.86-1.178-1.179.86-1.719a6.628 6.628 0 01-.889-2.143L.667 9.833V8.167l1.822-.608c.17-.773.475-1.496.889-2.143l-.86-1.72 1.179-1.178 1.719.86a6.628 6.628 0 012.143-.888L8.166.667zM9 14A5 5 0 109 4a5 5 0 000 10z"
        fill={color}
        fillOpacity={0.2}
      />
    </svg>
  );
};

export default Gear;
